import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const respuestaImporterSelectors = importerSelectors(
  'respuesta.importer',
);

export default respuestaImporterSelectors;
